// filepath: apps/web/src/design-system/error-states/FetchError.tsx
//
// Generic fetch-failure surface. Shows a non-sensitive message and a
// retry button. Never surfaces server error details (they may contain
// stack traces / credentials — INV-5).

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

export interface FetchErrorProps {
  message?: string;
  onRetry?: () => void;
}

export function FetchError({
  message,
  onRetry,
}: FetchErrorProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div
      data-testid="form-fetch-error"
      className="form-error form-fetch-error"
      role="alert"
    >
      <h2>Something went wrong</h2>
      <p>{message ?? "We could not load this form. Please try again."}</p>
      {onRetry ? (
        <button type="button" onClick={onRetry} data-testid="retry-button">
          {t("common.retry")}
        </button>
      ) : null}
    </div>
  );
}
